export default __webpack_public_path__ + "static/media/SignUpi.7e9ad807.svg";